import React from "react";
import { useRoutes } from "react-router-dom";
import { observer } from "mobx-react";
import routes from "./routes";

export const App: React.FC = observer(() => {
  return useRoutes(routes);
});
